import $ from "jquery";
import "bootstrap";
import Splide from "@splidejs/splide";

$(function () {
	let cast_carousel = document.querySelectorAll(".cast-slider");
	if (cast_carousel.length > 0) {
		for (let i = 0; i < cast_carousel.length; i++) {
			let cardsElement = cast_carousel[i];
			let cardsDefaultOptions = {
				autoWidth: false,
				type: "slide",
				rewind: false,
				start: 0,
				arrows: false,
				dots: true,
				perPage: 1,
				pagination: true,
				mediaQuery: "min",
				breakpoints: {
					768: {
						perPage: 2,
						gap: '1.5rem',
					},
					992: {
						perPage: 4,
						gap: '1rem',
					},
					1280: {
						perPage: 4,
						destroy: true,
					},
				},
			};

			let cards = new Splide(cardsElement, cardsDefaultOptions);
			cards.mount();
		}
	}
});